import { gsap, Power2 } from "gsap";

function animateText(element, duration, maxLength) {
    duration = duration || 1;
    maxLength = maxLength || 10;
  
    const items = element.children;
    const spans = Array.from(items).filter(
      (item) => item.tagName.toLowerCase() === "span"
    );
  
    if (spans.length && spans[0].classList.contains("animated")) return;
  
    const groups = Math.ceil(spans.length / maxLength);
  
    for (let i = 0; i < groups; i++) {
      const start = i * maxLength;
      const end = Math.min((i + 1) * maxLength, spans.length);
  
      const groupSpans = spans.slice(start, end);
  
      gsap.utils.toArray(groupSpans).forEach((span, index) => {
        gsap.fromTo(
          span,
          duration,
          { y: 50, ease: Power2.easeOut, opacity: 0, scaleY: 0.7 },
          {
            y: 0,
            ease: Power2.easeOut,
            opacity: 1,
            scaleY: 1,
            delay: 0.1 * (index + start),
          }
        );
      });
    }
  
    if (spans.length) {
      spans[0].classList.add("animated");
    }
  }

function checkVisible(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= windowHeight &&
    rect.right <= windowWidth
  );
}



// ...
const vScrollAnimate = {
    inserted(el, binding) {
      // 获取 maxLength 修饰符
      const maxLength = parseInt(Object.keys(binding.modifiers)[0], 10) || 100; // 默认值：100
      
      const animateIfVisible = () => {
        if (checkVisible(el)) {
          animateText(el, binding.value, maxLength);
        } else {
          // 移除 'animated' 类，使得动画在重新出现时被重置
          const items = el.children;
          const spans = Array.from(items).filter(
            (item) => item.tagName.toLowerCase() === "span"
          );
          if (spans.length && spans[0].classList.contains("animated")) {
            spans[0].classList.remove("animated");
          }
        }
      };
  
      const listener = () => {
        animateIfVisible();
      };
      window.addEventListener("scroll", listener);
  
      // 当元素首次插入时检查是否可见
      animateIfVisible();
    },
  };
  
  export default vScrollAnimate;


// WEBPACK FOOTER //
// ./src/utils/fontAnimate.js